export const IPSSecurityGuardTemplateHeaders = [
    { label: "Position", key: "position" },
    { label: "Security Officer", key: "securityOfficer" },
    { label: "Training Manager", key: "trainingManager" },
    { label: "Control Room Officer", key: "controlRoomOfficer" },
];

// Template data format used by SheetJS for Excel (in use)
export const IPSSecurityGuardTemplateExcelData = [
    { "Position": "Direct Costs" },
    { "Position": "Hourly Wage Rate" },
    { "Position": "Pension Insurance" },
    { "Position": "Unemployment Insurance" },
    { "Position": "Holiday Pay, Night-Shift Pay, Sunday Pay" },
    { "Position": "Continuation Of Payments (Sickness)" },
    { "Position": "Extra Vacation Payment" },
    { "Position": "Instruction Wage" },
    { "Position": "Clothing/Equipment" },
    { "Position": "Training Costs" },
    { "Position": "Hourly Costs Total" },
    { "Position": "Indirect Costs" },
    { "Position": "Overhead/Misc. General And Administrative Costs" },
    { "Position": "Profit" },
    { "Position": "Total" },
    { "Position": "Gross Margin" },
    { "Position": "Hourly Charge Total" },
    { "Position": "Initial Staffing Requirements For Cluster" },
    { "Position": "Hours Per Day" },
    { "Position": "Days Per Week" },
    { "Position": "Total Personnel" },
    { "Position": "Total Weekly Hours" },
    { "Position": "Weekly Charge" },
    { "Position": "Monthly Charge" },
    { "Position": "Annual Charge" }
];

// Template data format used by CSVLink from react-csv (deprecated)
export const IPSSecurityGuardTemplateData = [
    { position: "Direct Costs" },
    { position: "Hourly Wage Rate" },
    { position: "Pension Insurance" },
    { position: "Unemployment Insurance" },
    { position: "Holiday Pay, Night-Shift Pay, Sunday Pay" },
    { position: "Continuation Of Payments (Sickness)" },
    { position: "Extra Vacation Payment" },
    { position: "Instruction Wage" },
    { position: "Clothing/Equipment" },
    { position: "Training Costs" },
    { position: "Hourly Costs Total" },
    { position: "Indirect Costs" },
    { position: "Overhead/Misc. General And Administrative Costs" },
    { position: "Profit" },
    { position: "Total" },
    { position: "Gross Margin" },
    { position: "Hourly Charge Total" },
    { position: "Initial Staffing Requirements For Cluster" },
    { position: "Hours Per Day" },
    { position: "Days Per Week" },
    { position: "Total Personnel" },
    { position: "Total Weekly Hours" },
    { position: "Weekly Charge" },
    { position: "Monthly Charge" },
    { position: "Annual Charge" }
];

export const IPSSecurityGuardHeaderListForProcessing = IPSSecurityGuardTemplateHeaders.map(header => {
    return header.key;
});

export const IPSSecurityGuardBuyerProhibitedColumns = [
    'securityOfficer',
    'trainingManager',
    'controlRoomOfficer'
];

export const IPSSecurityGuardSupplierProhibitedColumns = IPSSecurityGuardTemplateHeaders.map(header => {
    if (!IPSSecurityGuardBuyerProhibitedColumns.includes(header.key)) {
        return header.key
    }
    return '';
});

export const IPSSecurityGuardHeaderListForCSV = IPSSecurityGuardTemplateHeaders.map(header => {
    return header.label;
}).join() + '\n';